import { render, staticRenderFns } from "./FbxModel.vue?vue&type=template&id=61053536&scoped=true"
import script from "./FbxModel.vue?vue&type=script&lang=js"
export * from "./FbxModel.vue?vue&type=script&lang=js"
import style0 from "./FbxModel.vue?vue&type=style&index=0&id=61053536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61053536",
  null
  
)

export default component.exports